module.exports = __webpack_public_path__ + "static/bluetropicalromper-5701249a1644d1e8a7e8da88722df5d3.jpeg";